// Menu Tableau de l’application parents, en français (voir boardViewApp.nl.ts).
export const appBoardViewFr = {
    title: 'Tableau',
    intro: 'Voici le tableau en ce moment, en direct. Lecture seule : on touche le tableau lui-même.',
    choose: 'Tableau',
    lastSeen: 'Vu pour la dernière fois {when}',
    neverSeen: 'Pas encore vu',
    virtual: 'iPad virtuel',
    viewOnly: 'Lecture seule',
    loading: 'Chargement du tableau…',
    reconnecting: 'Reconnexion…',
    revoked: 'Ce tableau a été dissocié.',
    failed: 'Impossible d’afficher le tableau.',
    retry: 'Réessayer',
    frameTitle: 'Tableau {name}, lecture seule',
    parentsOnly: 'Seuls les parents peuvent voir le tableau ici.',
    emptyTitle: 'Pas encore de tableau',
    emptyText: 'Associe une tablette et tu verras le tableau ici.',
    emptyLink: 'Associer une tablette',
};
//# sourceMappingURL=boardViewApp.fr.js.map